import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Meta Pixel Code
const pixelCode = `
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '1672445733721265');
fbq('track', 'PageView');
`;
const script = document.createElement('script');
script.innerHTML = pixelCode;
document.head.appendChild(script);
const noscript = document.createElement('noscript');
noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1672445733721265&ev=PageView&noscript=1" />`;
document.head.appendChild(noscript);
// End Meta Pixel Code
/*
  Access Token for Conversions API (Backend use):
  EAARuoPO6dXgBRNywNPyldfaMiw8LgqcP8WnySFJcapLjKNu23kyokdLPryUnWW4gxhulvU7IbIHHRVcvak4AhIErIDyHebGwIy5LM9sqx0BWjtmmn9sIzmaSbwDjr8GhKEaLJd0jbu328maKReK3gJZBRJvZC3exmZCMkG8jv7tsLzjLxlZCSkB5D8k1hViLuwZDZD
*/
render(<App data-id="element-18" />, document.getElementById('root'));